import { render, staticRenderFns } from "./CommingSoon.vue?vue&type=template&id=24858f25"
import script from "./CommingSoon.vue?vue&type=script&lang=js"
export * from "./CommingSoon.vue?vue&type=script&lang=js"
import style0 from "./CommingSoon.vue?vue&type=style&index=0&id=24858f25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports